import React from 'react';
import './GameGrid.css'
import './assets/balloon.png'

const games = [
  {
    title: 'Balloon Pop',
    image: require('./assets/balloon.png'),
    onClick: () => window.location.href = '/CamSkeleton',
  },

  {
    title: 'Balloon Pop',
    image: require('./assets/balloon.png'),
    onClick: () => window.location.href = '/CamSkeleton',
  },

  {
    title: 'Balloon Pop',
    image: require('./assets/balloon.png'),
    onClick: () => window.location.href = '/CamSkeleton',
  },

  {
    title: 'Balloon Pop',
    image: require('./assets/balloon.png'),
    onClick: () => window.location.href = '/CamSkeleton',
  },
  
  {
    title: 'Puddle Splash',
    image: require('./assets/puddle.png'),
    onClick: () => window.location.href = '/CamSkeletonPuddle',
  },

  {
    title: 'Puddle Splash',
    image: require('./assets/puddle.png'),
    onClick: () => window.location.href = '/CamSkeletonPuddle',
  },

  {
    title: 'Puddle Splash',
    image: require('./assets/puddle.png'),
    onClick: () => window.location.href = '/CamSkeletonPuddle',
  },

  {
    title: 'Puddle Splash',
    image: require('./assets/puddle.png'),
    onClick: () => window.location.href = '/CamSkeletonPuddle',
  },
  
];


const GameGrid = () => {
  return (
    <div className="game-grid-container">
      <h1 className="game-grid-title">Choose Your Game 🎮 </h1>
      <div className="game-grid">
        {games.map((game, index) => (
          <div className="game-card" key={index} onClick={game.onClick}>
            <img src={game.image} alt={game.title} className="game-image" />
            <div className="game-title">{game.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
};


export default GameGrid;


